<div class="text-right mb-3">
  <button (click)="goToAnalytics()" class="btn btn-primary me-2 align-right">
    <i class="fa fa-download me-2"> </i> Go to Analytics
  </button>
</div>
<div id="analytics-container" class="full_width_iframe"></div>
